import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
    {
        path: "/", //首页
        name: "index",
        component: (resolve) => require(['@/views/home/index.vue'], resolve)
    },
    {
        path: "/contract", //平台协议信息
        name: "contract",
        component: (resolve) => require(['@/views/home/contract.vue'], resolve)
    },
    {
        path: "/game", //游戏落地页
        name: "game",
        component: (resolve) => require(['@/views/LandingPage/game.vue'], resolve)
    },
    {
        path: "/app", //APP盒子落地页
        name: "app",
        component: (resolve) => require(['@/views/LandingPage/app.vue'], resolve)
    }
]


let router = new VueRouter({
    // base: '/dist',
    mode: 'history',
    disableDotRule: true,
    routes
})
export default router;


// WEBPACK FOOTER //
// ./src/router/index.js